import React from 'react';
// import './css/bootstrap.min.css';
import './css/font-awesome.min.css';
import './css/line-icons.css';
import './css/magnific-popup.css';
import './css/slicknav.css';
import './css/animate.css';
// import './css/main.css';
// import './css/responsive.css';
import { BrowserRouter as Router } from 'react-router-dom';
import MainRoutes from './MainRoutes';
import ScrollToTop from './ScrollToTop';
import './App.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

function App() {
    return (
        <Router>
            <div className="App">
                <ScrollToTop />
                <MainRoutes />
            </div>
        </Router>
    );
}

export default App;
